//@flow
import * as React from 'react';
import AcknowledgeButton from 'app/common/react/components/growth/unauth/signup/AccountRecovery/AcknowledgeButton';
import i18n from 'app/common/lib/i18n';
import Modal from 'app/common/react/ui/Modal';
import { interpolateNamedTemplate } from 'app/common/lib/react/interpolate';
import { SuspendedUserLink } from 'app/common/react/components/growth/unauth/signup/AccountRecovery/SuspendedUsers';
import { Box, Text } from 'gestalt';

type Props = {|
  onClose: () => void,
|};

export default function SuspendedModal({ onClose }: Props) {
  const oldString = i18n._(
    'Your account is suspended for violating our community guidelines. We previously sent you an email explaining why and how to appeal. If you have questions, {{ help_link }}.',
  );
  const stringToTranslate = i18n._(
    'Your account is suspended for violating our community guidelines. If you have questions, {{ help_link }}.',
  );
  const finalText = oldString || stringToTranslate;
  return (
    <Modal
      accessibilityCloseLabel={i18n._('close', 'accessible label for button to close modal')}
      accessibilityModalLabel={i18n._(
        'Login disabled for suspended account',
        'Modal accessibility label for when a user tries to login with a suspended account',
      )}
      heading={i18n._(
        'Your account has been suspended',
        'Modal heading for user who have attempted to login with a suspended account',
      )}
      onDismiss={onClose}
      role="alertdialog"
      size="md"
    >
      <Box paddingX={6} marginBottom={4}>
        <Box marginBottom={4}>
          <Text inline leading="tall">
            {interpolateNamedTemplate(finalText, {
              help_link: <SuspendedUserLink key="suspended user help_link" />,
            })}
          </Text>
        </Box>
        <Box marginTop={4}>
          <AcknowledgeButton
            color="red"
            onClick={onClose}
            overrideText={i18n._('Got it', 'Acknowledge suspended account modal message')}
          />
        </Box>
      </Box>
    </Modal>
  );
}
